import axios from "axios";
import { Chat, UserSignup } from "@/lib/types";
import { getURL } from "@/utils/util";
import { auth } from "@/auth";

export const fetchPosts = async (next?: string, params?: any) => {
  const baseUrl = getURL();
  const url = next ? next : `${baseUrl}blog/posts`;

  try {
    const response = await axios.get(url, { params });
    const blogPost = response.data;
    return {
      posts: blogPost.data,
      next: blogPost.next,
      previous: blogPost.previous,
      count: blogPost.count,
    };
  } catch (error) {
    console.error(error);
    throw new Error("error fetching posts");
  }
};

export const fetchTags = async () => {
  const baseUrl = getURL();
  const tagsResp = await fetch(`${baseUrl}blog/tags`);

  const tags = await tagsResp.json();

  return {
    tags: tags.data,
  };
};

export const getUserToken = async (username: string, password: string) => {
  const baseUrl = getURL();
  const response = await fetch(`${baseUrl}api-token-auth`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  const responseData = await response.json();
  console.log(responseData, 'responseDataresponseDataresponseData');
  console.log(response.headers, 'response.okresponse.okresponse.okresponse.headers');
  if (response.ok) {
    return responseData;
  } else {
    const errorMessages = responseData.non_field_errors;
    throw new Error(errorMessages);
  }
};

export const userSignUp = async (payload: UserSignup) => {
  const baseUrl = getURL();
  const response = await fetch(`${baseUrl}sign-up`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const responseData = await response.json();
  if (response.ok) {
    return responseData;
  } else {
    const errorMessages = responseData.non_field_errors; // TODO: fix error format
    throw new Error(errorMessages);
  }
};

export const searchPosts = async (query: string) => {
  const baseUrl = getURL();
  const response = await fetch(`${baseUrl}blog/posts?search=${query}`);
  const responseData = await response.json();
  if (response.ok) {
    return responseData;
  } else {
    throw new Error(responseData.detail);
  }
};

export const fetchPostSlugs = async () => {
  const baseUrl = getURL();
  const response = await fetch(`${baseUrl}blog/post-slug`);

  const slugs = await response.json();

  return slugs.data;
};

export const getPostBySlug = async (slug: string) => {
  const baseUrl = getURL();
  try {
    const response = await axios.get(`${baseUrl}blog/post/${slug}`);
    const post = response.data;
    return post;
  } catch (error) {
    console.log("Error", error);
  }
};

export const saveChatRequest = async (chat: Chat) => {
  const session = await auth();
  const token = session?.token;
  const baseUrl = getURL();

  // TODO: do global configuration for axios headers
  try {
    const response = await axios.post(`${baseUrl}chat/create`, chat, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Ginger-Bearer ${token}`,
      },
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const getChats = async (session: any) => {
  ;
  const token = session?.token;
  const baseUrl = getURL();

  try {
    const response = await axios.get(`${baseUrl}chat`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Ginger-Bearer ${token}`,
      },
    });
    return response.data?.results;
  } catch (error) {
    console.log("Error", error);
    return [];
  }
};


export const getChatById = async (session: any, chatID: string) => {
  ;
  const token = session?.token;
  const baseUrl = getURL();

  try {
    const response = await axios.get(`${baseUrl}chat/${chatID}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Ginger-Bearer ${token}`,
      },
    });
    if (response.status === 404) {
      return null;
    }
    return response.data;
  } catch (error) {
    console.log("Error", error);
    return null;
  }
};

export const deleteChat = async (session: any, chatID: string) => {
  const token = session?.token;
  const baseUrl = getURL();

  try {
    const response = await axios.delete(`${baseUrl}chat/delete/${chatID}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Ginger-Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error", error);
    return [];
  }
}

export const clearChat = async (session: any) => {
  const token = session?.token;
  const baseUrl = getURL();

  try {
    const response = await axios.delete(
      `${baseUrl}chat/clear`,
      {
        headers: {
          Authorization: `Ginger-Bearer ${token}`,
        },
      }
    );
    if (response.status === 204) {
      return true;
    }
  } catch (error) {
    console.log("error", error);
  }
};

export const getTags = async () => {
  const baseUrl = getURL();
  try {
    const response = await axios.get(`${baseUrl}blog/tags-hierarchy`);
    const tags = response.data;
    return tags;
  } catch (error) {
    console.log("Error", error);
  }
};


export const getFeaturedBlogPost = async () => {
  const baseUrl = getURL();
  try {
    const response = await axios.get(`${baseUrl}blog/featured`);
    const post = response.data;
    return response.data?.data;
  } catch (error) {
    console.log("Error", error);
  }
};
